(() => {
  if (window.fiegerWeeklyDealsInstalled) return;
  window.fiegerWeeklyDealsInstalled = true;
  document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-deal-variant]');
    if (!select) return;
    const card = select.closest('[data-deal-card]');
    const option = select.selectedOptions[0];
    if (!card || !option) return;
    card.querySelector('[data-deal-price]').textContent = option.dataset.price;
    const old = card.querySelector('[data-deal-old]');
    old.textContent = option.dataset.old;
    old.hidden = option.dataset.hasOld !== 'true';
    const available = option.dataset.available === 'true';
    const stock = card.querySelector('[data-deal-stock]');
    stock.textContent = available ? card.dataset.instock : card.dataset.soldout;
    stock.dataset.available = String(available);
    const button = card.querySelector('[data-deal-buy]');
    button.disabled = !available;
    button.textContent = available ? card.dataset.buy : card.dataset.soldout;
    card.querySelector('[data-deal-details]').href = option.dataset.url;
    const image = card.querySelector('.fieger-deal__image');
    if (image && option.dataset.image) {
      image.removeAttribute('srcset');
      image.src = option.dataset.image;
    }
  });
  const section = document.querySelector('[data-fieger-deals]');
  if (!section || window.Shopify?.designMode) return;
  const seconds = Number(section.dataset.boundary) - Number(section.dataset.serverNow);
  if (seconds > 0) window.setTimeout(() => window.location.reload(), seconds * 1000 + 1500);
})();
